import React, { Component } from "react";
import classnames from "classnames";

import {
    Field,
    IExoticTypeFieldProps,
} from "@formant/ui/component/common/Field";

import { Clock } from "./Clock";
import * as styles from "./DateTimeField.scss";

export interface IDateTimeProps extends Pick<
    IExoticTypeFieldProps,
    "label" | "disabled"
> {
    time: Date;
    maxTime?: Date | false;
    onTimeChanged: (dateTime: Date) => void;
}

export class DateTimeField extends Component<IDateTimeProps> {
    public render() {
        const { label, time, maxTime, disabled } = this.props;
        return (
            <Field
                label={label}
                collapsed={false}
                className={classnames(
                    styles["date-time-field"],
                    label && styles.labeled,
                )}
            >
                <Clock
                    time={time}
                    maxTime={maxTime}
                    onSelectTime={this.onSelectTime}
                    disabled={disabled}
                />
            </Field>
        );
    }

    private onSelectTime = (time: Date): void => {
        this.props.onTimeChanged(time);
    };
}
